import { BoxWrapper, Button, Modal } from 'components/Base';
import Fields from 'components/Fields';
import React from 'react';
import { Field, Form, InjectedFormProps, reduxForm } from 'redux-form';
import { compose } from 'ramda';
import { makeStyles } from '@material-ui/core';
import api from 'api';
import { Notify } from 'utils';

const useStyles = makeStyles({
  btnContainer: {
    display: 'flex',
    marginTop: '1rem',
    width: '100%',
    justifyContent: 'space-between'
  }
});

interface AssignClientModalProps {
  isOpen: boolean;
  close: Function;
  clientName: string;
  advisers: any;
  clients: any;
  updateClients: Function;
}

const AssignClientModal = ({
  isOpen,
  close,
  clientName,
  advisers,
  clients,
  updateClients,
  handleSubmit,
  submitting
}: InjectedFormProps & AssignClientModalProps) => {
  const classes = useStyles();

  const onSubmit = (values: any) => {
    api
      .assignCustomers(clients, values.adviser_id)
      .then(({ data }: any) => {
        updateClients(data);
        Notify.success('Client assigned successfully.');
        close();
      })
      .catch(() => {
        Notify.error('Client could not be updated.');
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      closeModalFunc={() => {
        close();
      }}
    >
      <BoxWrapper title="Assign Client">
        <Form onSubmit={handleSubmit(onSubmit)} style={{ padding: '1rem' }}>
          Select an adviser to assign {clientName} to:
          <Field
            name={`adviser_id`}
            shrink
            fullWidth
            validate={Fields.Validators.required}
            displayEmpty
            options={advisers}
            component={Fields.SelectAuto}
          />
          <div className={classes.btnContainer}>
            <Button
              color="primary"
              onClick={() => {
                close();
              }}
            >
              Cancel
            </Button>
            <Button isLoading={submitting} type="submit">
              Save
            </Button>
          </div>
        </Form>
      </BoxWrapper>
    </Modal>
  );
};

export default compose(
  reduxForm({
    form: 'downloadModal'
  })
)(AssignClientModal);
